export const ESRoutes = {
  Root: '/',
  NotFound: '/404',
  AccessDenied: '/access-denied',
};
